import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'
import FontAwesome from 'react-fontawesome'
import Box from '../Layout/Box'
import BoxSection from '../Layout/BoxSection'
import ModalConfirmarAccion from '../Shared/ModalConfirmarAccion'
import ModalSelectorFromList from '../Shared/ModalSelectorFromList'
import SelectorInput from '../Shared/SelectorInput'


import { uniqueArray, isAllowedToViewComponent, romanize, getDivisa, formatcoin } from '../../utils/helpers';


import { showModalConfirmarAccion, showModalSelector, selectFromSelector, getParameterByName } from '../../actions/common'


import {
    seleccionarAprobacion,
    registerApprovalResult,
    updateInputs,
    crearAprobacionAdicional
} from '../../actions/solicitudservicio' 




class Aprobaciones extends Component {


    componentWillMount() {
        this.props.getParameterByName('SMMLV')
        this.props.getParameterByName('MATRIZ_APROBACION')
        this.props.getParameterByName('APROBADORES_ADICIONALES')
    }      


    componentWillReceiveProps() {
        this.setState({
            aprobadores: this.props.aprobadores
        })
    }

    constructor(props) {
		super(props)
		this.state = {
            aprobador_id: null,
            aprobadores: this.props.aprobadores
		}
    }

    rubros = false
    aprobador_id = null
    indexServicio = null




    approve = (aprobador_id, cencos, indexServicio, idServicio, divisa) => { 
        const indexCotizacion = this.props.solicitudservicio.get('cotizaciones').findIndex(c => c.getIn(['servicios', 0, 'id']) == idServicio)
        const indexAprobacion = this.props.solicitudservicio.getIn(['cotizaciones', indexCotizacion, 'aprobaciones']).findIndex(a => a.get('aprobador_id') == aprobador_id)
        const tipo = this.props.solicitudservicio.getIn(['cotizaciones', indexCotizacion, 'aprobaciones', indexAprobacion, 'tipo'])

        this.rubros = false

        if (tipo == 1) {
            //this.rubros = true
        }

        this.aprobador_id  = aprobador_id
        this.indexServicio = indexServicio
        const aprobaciones = this.props.aprobadores.filter(u => u.get('id') == aprobador_id).first().get('aprobaciones').filter(x => x.getIn(['cotizacione', 'servicios', 0, 'id']) == idServicio)
        const observaciones = this.getObservacion(aprobador_id,idServicio);
        const setaprobaciones = aprobaciones.setIn([0,'observaciones'] , observaciones);

        this.props.showModalConfirmarAccion(true,
            `Al hacer click en Ok, estará aprobando el cargue de ${ formatcoin( (this.getTotal(this.aprobador_id)), divisa.simbolo ) } 
            ${cencos.length > 1 ? 'entre los ' : 'al'} centro${cencos.length > 1 ? 's' : ''} de costo ${uniqueArray(cencos).join(', ') }
            ${this.props.solicitudservicio.get('tipo') == 5 ? `y con la fecha de entrega ${moment(this.props.solicitudservicio.get('fecha_requerido')).format('DD/MM/YYYY')} `: '' }`,
            () => { this.props.showModalConfirmarAccion(false); this.props.registerApprovalResult(setaprobaciones, 2, indexServicio)}, true) 
    }

    reject = (aprobadorid, servicioid) => {

        this.rubros = false;
        this.indexServicio = null;

        const indexCotizacion = this.props.solicitudservicio.get('cotizaciones').findIndex(c => c.getIn(['servicios', 0, 'id']) == servicioid)
        const indexAprobacion = this.props.solicitudservicio.getIn(['cotizaciones', indexCotizacion, 'aprobaciones']).findIndex(a => a.get('aprobador_id') == aprobadorid)
        const observaciones = this.props.solicitudservicio.getIn(['cotizaciones', indexCotizacion, 'aprobaciones', indexAprobacion, 'observaciones'])

        let aprobaciones = this.props.aprobadores.filter(u => u.get('id') == aprobadorid).first().get('aprobaciones').filter(x => x.getIn(['cotizacione', 'servicios', 0, 'id']) == servicioid)
        aprobaciones = aprobaciones.setIn([0, 'observaciones'], observaciones)  

        this.props.showModalConfirmarAccion(true, `¿Esta seguro que desea rechazar esta solicitud?`, () => { this.props.showModalConfirmarAccion(false); this.props.registerApprovalResult(aprobaciones, 0)})

    }


    getTotal = (aprobador_id) => {

        let total = 0

        const aprobacion = this.props.aprobadores.filter(u => u.get('id') == aprobador_id).first().get('aprobaciones').filter(a => a.get('estado') == 3)


        if (aprobacion.count() > 0) {

            const cotizado = aprobacion.first().getIn(['cotizacione', 'cotizado_iva']) * aprobacion.first().getIn(['cotizacione', 'servicios', 0, 'cantidad'])

            if (aprobacion.first().get('tipo') < 2) {
                // aprobador_id = aprobacion.first().get('aprobador_original_id') || aprobador_id 
                total = aprobacion.first().getIn(['cotizacione', 'servicios', 0, 'cencos']).filter(cenco => cenco.get('responsable_id') == aprobador_id).reduce((acc, ele) => {
                    acc += ((cotizado * ele.getIn(['pivot', 'porcentaje'])) / 100)
                    return acc
                }, 0)

            } else {

                total = aprobacion.first().getIn(['cotizacione', 'servicios', 0, 'cencos']).reduce((acc, ele) => {
                    acc += ((cotizado * ele.getIn(['pivot', 'porcentaje'])) / 100)
                    return acc
                }, 0)
            }

        }

        return total

    }


    getSolicitudRechazada = (aprobaciones) => {
        return aprobaciones.filter(x => x.get('estado') == 0).count() == aprobaciones.count() 
    }


    getSolicitudAprobadas = (aprobaciones) => {
        return (aprobaciones.filter(x => x.get('estado') == 2).count() > 0) 
    }


    getSolicitudAprobadasEnRevision = (aprobaciones) => {
        return (aprobaciones.filter(x => x.get('estado') == 3).count() > 0) 
    }


    
    getEstadoAprobacion = (index, servicioid) => {
        if (index < this.props.aprobadores.count()) {
            const aprobaciones = this.props.aprobadores.getIn([index, 'aprobaciones']).filter(a => a.getIn(['cotizacione', 'servicios', 0, 'id']) == servicioid)
            if (aprobaciones.count() > 0) {
                if (this.getSolicitudRechazada(aprobaciones)) return 0
                if (this.getSolicitudAprobadas(aprobaciones)) return 2
                if (this.getSolicitudAprobadasEnRevision(aprobaciones)) return 3
                return 1
            }
        }
        return 1
    }



    getObservacion = (aprobadorid, servicioid) => {
        const cotizacion = this.props.solicitudservicio.get('cotizaciones').filter(c => c.getIn(['servicios', 0, 'id']) == servicioid)
        const aprobacion = cotizacion && cotizacion.count() > 0 ? cotizacion.first().get('aprobaciones').filter(a => a.get('aprobador_id') == aprobadorid) : null
        const observacion = aprobacion && aprobacion.count() > 0 ? aprobacion.first().get('observaciones') : ''
        return observacion
    }


    getPathObservacion = (aprobadorid, servicioid) => {
        const indexCotizacion = this.props.solicitudservicio.get('cotizaciones').findIndex(c => c.getIn(['servicios', 0, 'id']) == servicioid)
        const indexAprobacion = this.props.solicitudservicio.getIn(['cotizaciones', indexCotizacion, 'aprobaciones']).findIndex(a => a.get('aprobador_id') == aprobadorid)
        return `solicitud.cotizaciones.${indexCotizacion}.aprobaciones.${indexAprobacion}.observaciones`
    }


    handleOpenSelectorAprobador = (cotizacionId) => {
        const fields = [
            { id: 1, caption: 'Nombre', value: 'fullname', width: '40%' },
            { id: 2, caption: 'Cargo', value: 'cargo', width: '40%' },
            { id: 3, caption: 'Miembro', value: 'esmiembrocomite', width: '20%' }
        ];
        this.props.showModalSelector(
            'Seleccione aprobador adicional',
            fields,
            '/usuarios/aprobadores-adicionales',
            (aprobador) => this.setState({ [`aprobadorAdicional_${cotizacionId}`]: aprobador })
        );
    };



    tipo_corte = (cotizadoIva) => {

        const { smmlv, matriz_aprobacion } = this.props

        let tipoAprobacion = 1         

        const totalSMMLV = (smmlv && (cotizadoIva / parseFloat(smmlv.first().get('SMMLV')))) || 0;

        const match = matriz_aprobacion && matriz_aprobacion.find(item =>
            parseFloat(item.get('DESDE_SMMLV')) <= totalSMMLV && totalSMMLV < parseFloat(item.get('HASTA_SMMLV'))
        );

        if (match) {
            tipoAprobacion = match && parseInt(match.get('TIPO_APROBACION')) || 1;
        }

        return tipoAprobacion;
        
    } 
    
    
    info_aprobador_adicional = (aprobador) => {
        const { aprobadores_adicionales } = this.props;
        if (!aprobador) return null;
        if (!aprobadores_adicionales) return null;
        const aprobadorInfo = aprobadores_adicionales.find(a => a.get('USUARIO') === aprobador.get('username'));
        if (!aprobadorInfo) return null;
        return {
            cargo: aprobadorInfo.get('CARGO') || 'Sin cargo',
            esmiembrocomite: aprobadorInfo.get('MIEMBRO_COMITE') === 'SI'
        };
    }



	render() {
        
        const { id, solicitudservicio, aprobadores, btnAproveDisabled, divisas, enums } = this.props
        //console.log("# entrada de datos 1", aprobadores.toJS())
        if (!id) return null

		return (
            <div>
                {
                   solicitudservicio.get('servicios').map((servicio, iservicio) => {
                        return [

                            (iservicio > 0) ? <div key={ `sep1[${iservicio}]` } className="separator" /> : null,
                            (iservicio > 0) ? <div key={ `sep2${iservicio}]` } className="separator" /> : null,
                            (iservicio > 0) ? <div key={ `sep3${iservicio}]` } className="separator" /> : null,
                            (iservicio > 0) ? <div key={ `sep4[${iservicio}]` } className="separator" /> : null,


                            <Box key={ `bs[${iservicio}]` } title={ `Servicio No ${iservicio + 1} - ${servicio.get('descripcion')  || ''}` } >
                                {solicitudservicio.get('tipo') == 5 && (
                                    <div className="row">
                                        <div className="col-md-12">
                                            <span>Fecha de entrega: </span><b>{moment(solicitudservicio.get('fecha_requerido')).format('DD/MM/YYYY')}</b>
                                        </div>
                                    </div>
                                )}
                                <div className="separator"></div>
                                {/* Caja de solicitud de aprobación adicional ANTES de las aprobaciones principales */}
                                {(() => {
                                    // Buscar la cotización asociada a este servicio
                                    const cotizacion = solicitudservicio.get('cotizaciones').find(c => c.getIn(['servicios', 0, 'id']) === servicio.get('id'));
                                    if (!cotizacion) return null;
                                    const cotizacionId = cotizacion.get('id');
                                    const aprobaciones = cotizacion.get('aprobaciones');
                                    const cotizadoIva = cotizacion ? Number(cotizacion.get('cotizado_iva')) : 0;
                                    const tipo_corte = this.tipo_corte(cotizadoIva);


                                    // Estados locales para selector y motivo
                                    const solicitar = this.state && this.state[`solicitarAprobacionAdicional_${cotizacionId}`];
                                    const aprobador = this.state && this.state[`aprobadorAdicional_${cotizacionId}`];
                                    const motivo = this.state && this.state[`motivoAprobacionAdicional_${cotizacionId}`] || '';
                                    
                                    // Función para manejar el envío de la aprobación adicional
                                    const handleEnviarAprobacionAdicional = async function (cotizacionId, servicioId) {
                                        const cotizacion = this.props.solicitudservicio.get('cotizaciones').find(c => c.get('id') === cotizacionId);
                                        const aprobador = this.state[`aprobadorAdicional_${cotizacionId}`];
                                        const motivo = this.state[`motivoAprobacionAdicional_${cotizacionId}`] || '';
                                        if (!cotizacion || !aprobador || !motivo.trim()) return;
                                        await this.props.crearAprobacionAdicional({ cotizacion, aprobador, motivo });
                                        this.setState({
                                            [`solicitarAprobacionAdicional_${cotizacionId}`]: false,
                                            [`aprobadorAdicional_${cotizacionId}`]: null,
                                            [`motivoAprobacionAdicional_${cotizacionId}`]: ''
                                        });
                                    };
                                    return (tipo_corte === 1 && solicitudservicio.get('estado') === 3) && (
                                        <BoxSection title="Aprobación adicional">
                                            <div className="row">
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                checked={!!solicitar}
                                                                onChange={e => this.setState({ [`solicitarAprobacionAdicional_${cotizacionId}`]: e.target.checked })}
                                                            />
                                                            <span style={{marginLeft: '7px'}}>Solicitar aprobación adicional</span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    {solicitar && (
                                                        <div className="form-group">
                                                            <label className="control-label">Seleccione aprobador adicional</label>
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <SelectorInput
                                                                    value={aprobador ? aprobador.fullname : ''}
                                                                    onClick={() => this.handleOpenSelectorAprobador(cotizacionId)}
                                                                    onReset={() => this.setState({ [`aprobadorAdicional_${cotizacionId}`]: null })}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                {solicitar && aprobador && (
                                                    <Fragment>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label className="control-label">Cargo del aprobador:</label>
                                                                <div className="form-control input-sm" style={{ background: '#f9f9f9', paddingTop: '5px' }}>
                                                                    {aprobador.cargo || 'Sin cargo'}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3" style={{ display: 'flex', alignItems: 'center', marginTop: 25 }}>
                                                            {aprobador.esmiembrocomite === 'SI' && (
                                                                <span className="label label-success" style={{ fontSize: 13 }}>
                                                                    Integrantes del Comité de Rectoría
                                                                </span>
                                                            )}
                                                        </div>
                                                    </Fragment>
                                                )}
                                            </div>
                                            {solicitar && aprobador && (
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label className="control-label">Motivo de la solicitud adicional</label>
                                                            <textarea
                                                                rows={3}
                                                                className="form-control input-sm"
                                                                value={motivo}
                                                                onChange={e => this.setState({ [`motivoAprobacionAdicional_${cotizacionId}`]: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {solicitar && aprobador && (
                                                <div className="row">
                                                    <div className="col-md-12" style={{ textAlign: 'right', paddingTop: '10px', paddingBottom: '10px' }}>
                                                        <button
                                                            className="btn btn-primary btn-sm"
                                                            disabled={!motivo.trim()}
                                                            onClick={() => handleEnviarAprobacionAdicional.call(this, cotizacionId, servicio.get('id'))}
                                                        >
                                                            Enviar solicitud adicional
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </BoxSection>
                                    );
                                })()}
                                {/* Aprobaciones principales */}
                                {aprobadores.map((aprobador,iaprobador) => {

                                    const aprobaciones = aprobador.get('aprobaciones').filter( x => x.getIn(['cotizacione', 'servicios', 0, 'id']) == servicio.get('id'))
                                    const estado = this.getEstadoAprobacion(iaprobador, servicio.get('id'))
                                    
                                    const cencos = []

                                    if (aprobaciones.count() == 0) return null;
                                    
                                    const moneda = aprobaciones.first().getIn(['cotizacione','moneda']) ? aprobaciones.first().getIn(['cotizacione','moneda']) : 'COP'
                                    const divisa = getDivisa(divisas, moneda)

                                    const info_aprobador_adicional = this.info_aprobador_adicional(aprobador); 

                                    console.log("# aprobador: ", info_aprobador_adicional);

                                    return (
                                        <Fragment key={ `fr[${iservicio}][${iaprobador}]` }>

                                            <BoxSection                                                 
                                                title={ 
                                                    <span>                                                      
                                                        {aprobaciones.first().get('tipo') === 3 ? (
                                                            <span style={{ color: '#fff', fontWeight: 600 }}>
                                                                Solicitud de aprobación adicional a <strong>{ aprobador.get('fullname') }</strong>
                                                            </span>
                                                        ) : (
                                                            <Fragment>
                                                                Solicitud de aprobación nivel { romanize(aprobaciones.first().get('tipo')) } a <strong>{ aprobador.get('fullname') }</strong>
                                                            </Fragment>
                                                        )}
                                                    </span>
                                                }
                                            >

                                                {info_aprobador_adicional && (
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <span style={{ fontWeight: 500 }}>
                                                                Cargo: {info_aprobador_adicional.cargo || 'Sin cargo'}
                                                            </span>
                                                            {info_aprobador_adicional.esmiembrocomite ? (
                                                                <span className="label label-success" style={{ marginLeft: 10 }}>
                                                                    Integrantes del Comité de Rectoría
                                                                </span>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="row">
                                                    <div className="col-md-12"> 
                                                        <h4>Solicitud de aprobación: { enums.aprobaciones.estados[estado] }{ estado === 1 ? '' : <span> &bull; { aprobaciones.first().get('fecha') ? moment(aprobaciones.first().get('fecha')).format('YYYY-MM-DD HH:mm') : null }</span> }</h4>
                                                    </div>
                                                </div>

                                                {      
                                                    
                                                    (estado == 2 && aprobaciones.filter(a => a.get('estado') == 2).first().get('aprobador_su')) && (
                                                        <Fragment>
                                                        <div key={ `sep2[${iservicio}][${iaprobador}]` } className="separator" />
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <span>Esta solicitud fue aprobada por <b>{ aprobaciones.first().getIn(['aprobador_su', 'fullname']) }</b></span>                                                
                                                            </div>
                                                        </div>                                        
                                                        </Fragment>
                                                    )
                                                }    


                                                {      
                                                    
                                                    (estado == 0 && aprobaciones.filter(a => a.get('estado') == 0).first().get('aprobador_su')) && (
                                                        <Fragment>
                                                        <div key={ `sep2[${iservicio}][${iaprobador}]` } className="separator" />
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <span>Esta solicitud fue rechazada por <b>{ aprobaciones.first().getIn(['aprobador_su', 'fullname']) }</b></span>                                                
                                                            </div>
                                                        </div>                                        
                                                        </Fragment>
                                                    )
                                                }

                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <span>Solicitada por <b>{ solicitudservicio.getIn(['solicitante', 'fullname']) }</b></span> &bull; <span><a href={ `mailto:${solicitudservicio.getIn(['solicitante', 'email'])}` }>{ solicitudservicio.getIn(['solicitante', 'email']) }</a></span>
                                                    </div>
                                                </div>



                                                <div key={ `sep2[${iservicio}][${iaprobador}]` } className="separator" /> 

                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <b>Detalle:</b>
                                                    </div>
                                                </div>

                                                <div key={ `sep3[${iservicio}][${iaprobador}]` } className="separator" />                                             


                                                <div key={`row[${iservicio}][${iaprobador}]`} className="row">
                                                    <div className="col-md-12">
                                                        <table className="table table-condensed table-bordered table-striped" id="aprobaciones"> 
                                                            <thead>
                                                                <tr>
                                                                    <th style={{ width: '10%', textAlign: 'center' }}>Seleccionar</th>
                                                                    <th style={{ width: '10%', textAlign: 'center' }} >Proveedor</th>
                                                                    <th style={{ width: '10%', textAlign: 'center' }}>Valor cotizado</th>
                                                                    <th style={{ width: '10%', textAlign: 'center' }}>Valor a aprobar</th>
                                                                    <th style={{textAlign: 'center'}}>Distribución de cenco</th>
                                                                    <th style={{width: '50px', textAlign: 'center'}}></th>                                                                                
                                                                </tr>
                                                            </thead> 
                                                            <tbody>
                                                            {
                                                               aprobaciones.map((aprobacion,iaprobacion) => {
                                                                    

                                                                    let totalAprobar_porcentaje = 100
                                                                    
                                                                    const aprobador_id = aprobador.get('id')
                                                                    if (aprobacion.get('tipo') < 2) {
                                                                        totalAprobar_porcentaje = aprobacion.getIn(['cotizacione', 'servicios', '0', 'cencos']).
                                                                        filter(x => x.get('responsable_id') == aprobador_id).
                                                                        reduce((a,b) => {a += Number(b.getIn(['pivot', 'porcentaje'])) ; return a }, 0)
                                                                    }

                                                                    const totalAprobar = (totalAprobar_porcentaje / 100) * aprobacion.getIn(['cotizacione', 'cotizado_iva']) * servicio.get('cantidad')

                                                                    return (

                                                                        <tr key={`tr[${iservicio}][${iaprobador}[${iaprobacion}]]`}>

                                                                            <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '15px' }}>                                                                               

                                                                            {
                                                                                estado == 0 || estado == 2 ? (
                                                                                    <Fragment>
                                                                                    {
                                                                                        aprobacion.get('estado') == 2 && (<FontAwesome name="check" style={{ color: 'green', fontSize: '30px' }} />)
                                                                                    }
                                                                                    </Fragment>
                                                                                ):(
                                                                                    <Fragment>
                                                                                    {
                                                                                        aprobacion.get('estado') == 2 || aprobacion.get('estado') == 3 ? (
                                                                                    
                                                                                            <button>
                                                                                                <FontAwesome name="check" style={{ color: 'green', fontSize: '30px' }} />
                                                                                            </button>
                                                                                    
                                                                                        ):(
                                                                                            <button style={{ width: '45px', height: '35px' }} onClick={() => this.props.seleccionarAprobacion(servicio.get('id'), aprobador.get('id'), aprobacion.get('id'))} ></button>
                                                                                        )
                                                                                    }
                                                                                    </Fragment>                                                                                    
                                                                                )
                                                                            }

                                                                            </td>

                                                                            <td style={{ verticalAlign: 'middle' }}>
                                                                                { (aprobacion.getIn(['cotizacione', 'proveedore', 'nombre']) == null ? ' COMPRA DIRECTA': aprobacion.getIn(['cotizacione', 'proveedore', 'nombre'])) }

                                                                            </td>

                                                                            <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                                                { formatcoin( (aprobacion.getIn(['cotizacione', 'cotizado_iva']) * servicio.get('cantidad')), divisa.simbolo ) }
                                                                            </td>

                                                                            <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{ formatcoin( totalAprobar, divisa.simbolo ) }</td>


                                                                            <td>
                                                                                <table className="table table-condensed table-bordered table-striped" id="dist-cenco">
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <th style={{ textAlign: 'center' }}>Cenco</th>
                                                                                            <th style={{ textAlign: 'center' }}>Rubro</th>
                                                                                            <th style={{ textAlign: 'center' }}>%</th>
                                                                                            <th style={{ textAlign: 'center' }}>Valor</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>                                                                                    
                                                                                        {
                                                                                            aprobacion.getIn(['cotizacione', 'servicios', '0', 'cencos']).map((cenco, icenco) => {

                                                                                                const indexCenco = cencos.findIndex(x => x == cenco.get('codigo'))
                                                                                                if (indexCenco == -1) cencos.push(cenco.get('codigo'))

                                                                                                if ((aprobacion.get('tipo') < 2) && cenco.get('responsable_id') != aprobador_id && cenco.getIn(['pivot', 'aprobador_id']) != aprobador_id) return null

                                                                                                return (
                                                                                                    <tr key={ `tr2[${iservicio}][${iaprobador}][${iaprobacion}][${icenco}]`}>
                                                                                                        <td><span title={ `${cenco.get('descripcion')}` }>{ cenco.get('codigo') }</span></td>
                                                                                                        <td><span title={ `${cenco.getIn(['pivot', 'rubro', 'descripcion'])}` }>{ cenco.getIn(['pivot', 'rubro', 'nombre']) }</span></td>
                                                                                                        <td style={{ textAlign: 'right' }}>{ numeral(cenco.getIn(['pivot', 'porcentaje']) / 100).format('0.0%') }</td>
                                                                                                        <td style={{ textAlign: 'right' }}>{ formatcoin( ((cenco.getIn(['pivot', 'porcentaje']) / 100) * aprobacion.getIn(['cotizacione', 'cotizado_iva']) * servicio.get('cantidad')), divisa.simbolo ) }</td>
                                                                                                    </tr>
                                                                                                )

                                                                                            })
                                                                                        }
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>

                                                                            <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                                            {
                                                                                aprobacion.getIn(['cotizacione', 'recomendado']) && (
                                                                                    <FontAwesome name="star" style={{ color: 'goldenrod', fontSize: '30px' }} title={"Recomendado"} />

                                                                                )
                                                                            }
                                                                            </td>

                                                                        </tr>
                                                                    )
                                                                })
                                                            }                                                                
                                                            </tbody>                                                                   
                                                        </table>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label className="control-label">Observaciones</label>
                                                            <textarea 
                                                                rows={6} 
                                                                className="form-control input-sm" 
                                                                value={ 
                                                                    this.getObservacion(aprobador.get('id'), servicio.get('id')) || ''
                                                                } 
                                                                onChange={ 
                                                                    (e) => this.props.updateInputs(this.getPathObservacion(aprobador.get('id'), servicio.get('id')), e.target.value) 
                                                                } 
                                                                disabled = { (estado != 1 && estado != 3) || solicitudservicio.get('estado') == 0 || !isAllowedToViewComponent('aprobaciones', aprobador) || aprobaciones.first().get('tipo') === 3}
                                                                />
                                                        </div>
                                                    </div>
                                                </div>

        

                                                <div className="separator"></div>  

                                                {
                                                    (estado == 1 || estado == 3) && (isAllowedToViewComponent('aprobaciones', aprobador)) && solicitudservicio.get('estado') > 0 && (
                            
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div style={{ textAlign: 'right', padding: '10px 0' }}> 
                                                                    <span>
                                                                        <button className="btn btn-primary btn-sm btn-squared" onClick={ () => this.approve(aprobador.get('id'), cencos, iservicio, servicio.get('id'), divisa) } disabled={ btnAproveDisabled }>Aprobar</button>
                                                                    </span>
                                                                    <span style={{ marginLeft: '10px' }}>
                                                                        <button className="btn btn-default btn-sm btn-squared" onClick={ e => this.reject(aprobador.get('id'), servicio.get('id')) } disabled={ btnAproveDisabled }>Rechazar</button>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>         

                                                    )
                                                }


                                            </BoxSection>

                                        </Fragment>
                                    )
                                })}

                                <ModalConfirmarAccion>

                                {this.rubros && (                    
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Box title="Selección de rubros" onModal>
                                                <div className="box-content" style={{ height: '81px', overflowX: 'hidden' }}>
                                                    <table className="table table-condensed">
                                                        <tbody>
                                                            { 
                                                                this.props.solicitudservicio.getIn(['servicios', this.indexServicio, 'cencos']).filter(c => c.get('responsable_id') == this.aprobador_id).map((x, n) => {  
                                                                    if (x.get('rubros').count() > 0) {  
                                                                        const index = this.props.solicitudservicio.getIn(['servicios', this.indexServicio, 'cencos']).findIndex(f => f.get('id') === x.get('id'));
                                                                        if (index < 0) return null                                                    
                                                                        return (
                                                                            <tr key={ `tr[${x.get('id')}]` }>
                                                                                <td style={{ width: '20px', verticalAlign: 'middle' }} ><span>{ n + 1 }</span></td>
                                                                                <td style={{ width: '55%' }} ><input type="text" className="form-control input-sm" value={ x.get('descripcion') ? x.get('descripcion') : '' } disabled /></td>
                                                                                <td style={{ width: '45%' }}>
                                                                                    <select className="form-control input-sm" value={ Number(x.getIn(['pivot', 'rubro_id'])) || 0 } onChange={ (e) => { this.props.updateInputs(`solicitud.servicios.${this.indexServicio}.cencos.${index}.pivot.rubro_id`, Number(e.target.value)) } }>
                                                                                        <option value={ 0 } disabled>Seleccione una opción</option>
                                                                                        {x.get('rubros').map((r,j) => {
                                                                                            return(
                                                                                                <option key={`optr[${j}]`} value={r.get('id')}>{r.get('nombre')}</option>
                                                                                            )
                                                                                        })}
                                                                                    </select>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    }
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </Box>
                                        </div>
                                    </div>
                                )}

                                </ModalConfirmarAccion>
                                <ModalSelectorFromList />
                                
                            </Box>

                        ]
                    })
                }

                <ModalConfirmarAccion>

                {this.rubros && (                    
                    <div className="row">
                        <div className="col-md-12">
                            <Box title="Selección de rubros" onModal>
                                <div className="box-content" style={{ height: '81px', overflowX: 'hidden' }}>
                                    <table className="table table-condensed">
                                        <tbody>
                                            { 
                                                this.props.solicitudservicio.getIn(['servicios', this.indexServicio, 'cencos']).filter(c => c.get('responsable_id') == this.aprobador_id).map((x, n) => {  
                                                    if (x.get('rubros').count() > 0) {  
                                                        const index = this.props.solicitudservicio.getIn(['servicios', this.indexServicio, 'cencos']).findIndex(f => f.get('id') === x.get('id'));
                                                        if (index < 0) return null                                                    
                                                        return (
                                                            <tr key={ `tr[${x.get('id')}]` }>
                                                                <td style={{ width: '20px', verticalAlign: 'middle' }} ><span>{ n + 1 }</span></td>
                                                                <td style={{ width: '55%' }} ><input type="text" className="form-control input-sm" value={ x.get('descripcion') ? x.get('descripcion') : '' } disabled /></td>
                                                                <td style={{ width: '45%' }}>
                                                                    <select className="form-control input-sm" value={ Number(x.getIn(['pivot', 'rubro_id'])) || 0 } onChange={ (e) => { this.props.updateInputs(`solicitud.servicios.${this.indexServicio}.cencos.${index}.pivot.rubro_id`, Number(e.target.value)) } }>
                                                                        <option value={ 0 } disabled>Seleccione una opción</option>
                                                                        {x.get('rubros').map((r,j) => {
                                                                            return(
                                                                                <option key={`optr[${j}]`} value={r.get('id')}>{r.get('nombre')}</option>
                                                                            )
                                                                        })}
                                                                    </select>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </Box>
                        </div>
                    </div>
                )}

                </ModalConfirmarAccion>
                <ModalSelectorFromList />
                
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        id: state.solicitudservicio.get('id'),
        solicitudservicio: state.solicitudservicio.get('solicitud'),
        aprobadores: state.solicitudservicio.get('aprobadores'),
        user: state.common.get('user'),
        modalConfirmarAccion: state.common.get('modalConfirmarAccion'),
        btnAproveDisabled: state.solicitudservicio.get('btnAproveDisabled'),
        divisas: state.common.getIn(['parametros', 'DIVISAS']),
        enums: state.common.get('enums').toJS(),
        smmlv: state.common.getIn(['parametros', 'SMMLV']),
        matriz_aprobacion: state.common.getIn(['parametros', 'MATRIZ_APROBACION']),
        aprobadores_adicionales: state.common.getIn(['parametros', 'APROBADORES_ADICIONALES']),
    }
}





function mapDispatchToProps(dispatch) {
    return {
        showModalConfirmarAccion: (show, message, action) => dispatch(showModalConfirmarAccion(show, message, action)),
        seleccionarAprobacion: (servicioid, aprobadorid, aprobacionid) => dispatch(seleccionarAprobacion(servicioid, aprobadorid, aprobacionid)),
        registerApprovalResult: (aprobaciones, result, indexServicio) => dispatch(registerApprovalResult(aprobaciones, result, indexServicio)),
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
        showModalSelector: (title, fields, url, action, customFilter) => dispatch(showModalSelector(title, fields, url, action, customFilter)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        crearAprobacionAdicional: (payload) => dispatch(crearAprobacionAdicional(payload)),
        getParameterByName: (param) => dispatch(getParameterByName(param)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Aprobaciones)





// WEBPACK FOOTER //
// ./src/components/SolicitudServicio/Aprobaciones.jsx